import React from 'react';
import Odd from '../Odd';

export default function BannerOdds(props) {
    const data = props.data;

    const bet = data.bet;
    let [team1, team2] = ['', ''];
    
    if (data.desc.includes(' - ')) {
        const parts = data.desc.split(' - ');
        [team1, team2] = [parts[0], parts[1]];
    } else {
        team1 = data.desc;
    }

    return (
        <div className="c_48">
            <div className="c_48_1">
                <span className="c_48_1_1">{team1}</span>
                {team2.length > 0 &&
                    <>
                        <span className="c_48_1_2"></span>
                        <span className="c_48_1_1">{team2}</span>
                    </>
                }
            </div>
            {/* {data.text &&
                <span className="c_48_1_2">{data.text}</span>
            } */}
            <div className="c_48_2">
                {bet.odds.map((odd, i) =>
                    <Odd key={odd.id} data={odd} type={props.type} showDesc={true} />
                )}
            </div>
        </div>
    );
}
